exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  font-family: \"Thasadith\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n", ""]);

// exports
